<template>
  <div
    @click="$emit('click')"
    @contextmenu="$emit('open-menu-object', $event)"
    class="object-label"
    :class="{ origin: side === 'origin', destination: side ==='destination' }"
  >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <p
          v-bind="attrs"
          v-on="on"
        >{{ objectName }}</p>
      </template>
      <span :style="{fontSize: '10px'}">{{ objectName }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "TableDataObject",

  props: {
    objectName: String,

    isSelected: Boolean,

    disabled: {
      type: Boolean,
      default: true
    },
    side:{
      type: String,
    }
  }
};
</script>

<style scoped>
.object-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 25px;
  position: absolute;
  border: .5px solid #4fa2b7;
  border-radius: 10px;
  background-color: white;
  padding: 0 3px;
}
.object-label p {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.origin{
  left: 5px;
}
.destination{
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataObject.vue